<template>
  <a-steps
    :class="[bem.b(), bem.is(mode)]"
    v-bind="attrs"
    :items="items.map(({ tip, ...rest }) => rest)"
    :current="newCurrent"
    label-placement="vertical"
  >
    <template #progressDot="{ index }">
      <component
        :is="items[index]?.tip ? 'll-tooltip' : 'div'"
        v-bind="items[index]?.tip ? { tip: items[index].tip } : {}"
      >
        <div
          v-if="index < newCurrent"
          :class="['dot-status', bem.m('dot-finish')]"
        >
          <ll-icon icon-name="icon-check" />
        </div>
        <div
          v-else-if="index === newCurrent"
          :class="[
            'dot-status',
            mode === 'flow-wizard' ? bem.m('dot-active') : bem.m('dot-finish'),
          ]"
        >
          <ll-icon
            :icon-name="mode === 'flow-wizard' ? 'icon-more' : 'icon-check'"
          />
        </div>
        <div v-else :class="['dot-status', bem.m('dot-pending')]">
          <div></div>
        </div>
      </component>
    </template>
  </a-steps>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { computed, useAttrs } from 'vue'
import { inlineStepperProps } from './inline-stepper'

defineOptions({
  name: 'LlInlineStepper',
})

const bem = createNamespace('inline-stepper')

const props = defineProps(inlineStepperProps)

const attrs = useAttrs()

const newCurrent = computed(() => {
  if (!Array.isArray(props.items)) return 0

  const index = props.items.findIndex((item) =>
    Object.values(item).includes(props.current),
  )

  return index === -1 ? undefined : index
})
</script>
